import type { AccessControlProvider } from "@refinedev/core";

import { loadMe } from "../session";

// Which permissions open each resource (docs/ARCHITECTURE.md → Office Permissions); a list
// needs all of them. This only hides menus, pages and buttons; apps/api checks every request.
export const RESOURCE_PERMISSIONS: Record<string, string | string[] | null> = {
  dashboard: "dashboard.view",
  tutors: "tutors.view",
  "profile-changes": "tutors.view",
  students: "students.view",
  users: ["students.view", "tutors.view"],
  lessons: "lessons.view",
  reviews: "reviews.view",
  "cancellation-requests": "lessons.view",
  orders: "orders.view",
  payouts: "payouts.view",
  staff: "staff.manage",
  roles: "staff.manage",
  "audit-log": "audit.view",
  support: "support.view",
  plans: "plans.manage",
  blog: "blog.manage",
  "message-reports": "messages.moderate",
  "question-reports": "questions.moderate",
  "system-errors": "system.errors",
  account: null,
};

/** Actions that need more than seeing the resource. */
const ACTION_PERMISSIONS: Record<string, string> = {
  "tutors.verify": "tutors.verify",
  "profile-changes.decide": "tutors.verify",
  "reviews.moderate": "reviews.moderate",
  "cancellation-requests.decide": "lessons.decideCancellation",
  "payouts.pay": "payouts.markPaid",
  "orders.refund": "orders.refund",
  "students.contact": "students.contact",
  "support.reply": "support.reply",
  "lessons.recordings": "lessons.recordings",
};

export const accessControlProvider: AccessControlProvider = {
  can: async ({ resource, action }) => {
    // Routes outside the resources (the 404 page) have nothing to protect.
    if (!resource) return { can: true };
    const required = ACTION_PERMISSIONS[`${resource}.${action}`] ?? RESOURCE_PERMISSIONS[resource];
    if (required === null) return { can: true };
    const me = await loadMe();
    const needed = required === undefined ? [] : [required].flat();
    const can =
      needed.length > 0 && needed.every((permission) => me?.permissions.includes(permission));
    return can ? { can } : { can, reason: "Bu sayfaya erişim yetkin yok." };
  },
  options: { buttons: { enableAccessControl: true, hideIfUnauthorized: true } },
};
